const importAll = (r) => r.keys().map(r);

const shuffle = (array) =>
  array
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);

export const getTexasThumbnails = (count = 8) => {
  const friscoThumbs = importAll(
    require.context(
      "../../../assets/images/events/gallery/frisco/day1/",
      false,
      /^\.\/\d+\.jpg$/
    )
  );

  const texasThumbs = importAll(
    require.context(
      "../../../assets/images/events/gallery/frisco/day2/",
      false,
      /^\.\/\d+\.jpg$/
    )
  );

  const combined = [...friscoThumbs, ...texasThumbs];

  return shuffle(combined).slice(0, count);
};

export const getMichThumbnails = (count = 8) => {
  const michiganThumbs = importAll(
    require.context(
      "../../../assets/images/events/gallery/grand rapids/day2/",
      false,
      /^\.\/1\s\(\d+\)\.jpg$/
    )
  );

  const michThumbs = importAll(
    require.context(
      "../../../assets/images/events/gallery/grand rapids/day1/",
      false,
      /^\.\/1\s\(\d+\)\.jpg$/
    )
  );

  const combined = [...michiganThumbs, ...michThumbs];

  return shuffle(combined).slice(0, count);
};

export const getHustonThumbnails = (count = 8) => {
  const hustonThumbs = importAll(
    require.context(
      "../../../assets/images/events/gallery/huston",
      false,
      /^\.\/1\s\(\d+\)\.jpg$/
    )
  );

  //   const hutThumbs = importAll(
  //     require.context(
  //       "../../../assets/images/events/gallery/grand rapids/day2/",
  //       false,
  //       /^\.\/a\s\(\d+\)\.jpg$/
  //     )
  //   );

  const combined = [...hustonThumbs];
  return shuffle(combined).slice(0, count);
};

export const getIngThumbnails = (count = 8) => {
  const ingThumbs = importAll(
    require.context(
      "../../../assets/images/events/gallery/ing",
      false,
      /^\.\/1\s\(\d+\)\.jpg$/
    )
  );

  //   const hutThumbs = importAll(
  //     require.context(
  //       "../../../assets/images/events/gallery/grand rapids/day2/",
  //       false,
  //       /^\.\/a\s\(\d+\)\.jpg$/
  //     )
  //   );

  const combined = [...ingThumbs];
  return shuffle(combined).slice(0, count);
};
